

import { useState } from 'react';

export default function Blogs() {
  const [visibleStories, setVisibleStories] = useState(6);
  const [isLoading, setIsLoading] = useState(false);

  const [activeFilter, setActiveFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');

  const filters = ['All', 'Culture', 'Youth', 'Communities', 'Micro-Knowledge'];

  const allStories = [
    {
      id: 1,
      title: "Traditional Pottery Making Revival in Downtown",
      excerpt: "Local artisans are bringing back the ancient art of pottery making, teaching young people traditional techniques passed down through generations.",
      author: "Maria Santos",
      date: "2024-01-15",
      category: "Culture",
      image: "https://readdy.ai/api/search-image?query=Traditional%20pottery%20making%20workshop%20with%20clay%20pots%20and%20artisan%20hands%20working%20on%20pottery%20wheel%20in%20warm%20studio%20lighting%20with%20earthy%20tones%20and%20cultural%20heritage%20atmosphere&width=400&height=250&seq=1&orientation=landscape",
      readTime: "5 min read"
    },
    {
      id: 2,
      title: "Youth Innovation Lab Opens New Opportunities",
      excerpt: "The new innovation lab provides young entrepreneurs with cutting-edge technology and mentorship to develop solutions for community challenges.",
      author: "David Chen",
      date: "2024-01-12",
      category: "Youth",
      image: "https://readdy.ai/api/search-image?query=Modern%20innovation%20lab%20with%20young%20people%20working%20on%20technology%20projects%20computers%20and%20collaborative%20workspace%20with%20bright%20lighting%20and%20innovative%20atmosphere&width=400&height=250&seq=2&orientation=landscape",
      readTime: "4 min read"
    },
    {
      id: 3,
      title: "Community Garden Transforms Vacant Lot",
      excerpt: "Neighbors came together to transform an abandoned lot into a thriving community garden that now feeds dozens of families.",
      author: "Sarah Johnson",
      date: "2024-01-10",
      category: "People",
      image: "https://readdy.ai/api/search-image?query=Vibrant%20community%20garden%20with%20diverse%20vegetables%20and%20flowers%20people%20working%20together%20in%20urban%20setting%20with%20green%20plants%20and%20collaborative%20community%20spirit&width=400&height=250&seq=3&orientation=landscape",
      readTime: "6 min read"
    },
    {
      id: 4,
      title: "Local Artist Creates Stunning Mural Series",
      excerpt: "A talented local artist has been commissioned to create a series of murals that tell the story of our neighborhood's rich history.",
      author: "Alex Rodriguez",
      date: "2024-01-08",
      category: "Culture",
      image: "https://readdy.ai/api/search-image?query=Colorful%20street%20mural%20being%20painted%20by%20artist%20with%20vibrant%20colors%20depicting%20community%20history%20and%20cultural%20themes%20on%20urban%20wall%20with%20artistic%20atmosphere&width=400&height=250&seq=4&orientation=landscape",
      readTime: "3 min read"
    },
    {
      id: 6,
      title: "Elderly Residents Share Life Stories",
      excerpt: "A beautiful initiative where elderly community members share their life experiences and wisdom with younger generations through storytelling sessions.",
      author: "Robert Kim",
      date: "2024-01-03",
      category: "People",
      image: "https://readdy.ai/api/search-image?query=Elderly%20person%20sharing%20stories%20with%20young%20people%20in%20comfortable%20community%20center%20setting%20with%20warm%20lighting%20and%20intergenerational%20connection%20atmosphere&width=400&height=250&seq=6&orientation=landscape",
      readTime: "5 min read"
    },
    {
      id: 7,
      title: "Street Food Festival Celebrates Diversity",
      excerpt: "The annual street food festival brought together vendors from different cultural backgrounds, showcasing the rich culinary diversity of our community.",
      author: "Lisa Thompson",
      date: "2024-01-01",
      category: "Culture",
      image: "https://readdy.ai/api/search-image?query=Vibrant%20street%20food%20festival%20with%20diverse%20food%20vendors%20colorful%20stalls%20people%20enjoying%20multicultural%20cuisine%20in%20festive%20outdoor%20atmosphere%20with%20cultural%20celebration&width=400&height=250&seq=7&orientation=landscape",
      readTime: "4 min read"
    },
    {
      id: 8,
      title: "Students Launch Environmental Initiative",
      excerpt: "High school students organized a comprehensive recycling program that has significantly reduced waste in local schools and neighborhoods.",
      author: "Michael Brown",
      date: "2023-12-28",
      category: "Youth",
      image: "https://readdy.ai/api/search-image?query=Students%20organizing%20recycling%20program%20with%20bins%20and%20environmental%20materials%20in%20school%20setting%20with%20green%20sustainability%20theme%20and%20youth%20activism%20atmosphere&width=400&height=250&seq=8&orientation=landscape",
      readTime: "6 min read"
    },
    {
      id: 9,
      title: "Local Library Hosts Digital Literacy Classes",
      excerpt: "The community library has started offering free digital literacy classes to help residents of all ages navigate the digital world with confidence.",
      author: "Jennifer Davis",
      date: "2023-12-25",
      category: "Innovation",
      image: "https://readdy.ai/api/search-image?query=Community%20library%20with%20people%20of%20different%20ages%20learning%20computer%20skills%20and%20digital%20literacy%20in%20educational%20setting%20with%20books%20and%20technology&width=400&height=250&seq=9&orientation=landscape",
      readTime: "5 min read"
    },
    {
      id: 10,
      title: "Neighborhood Watch Program Strengthens Safety",
      excerpt: "Residents have come together to create a neighborhood watch program that has improved community safety and fostered stronger relationships among neighbors.",
      author: "Thomas Wilson",
      date: "2023-12-22",
      category: "People",
      image: "https://readdy.ai/api/search-image?query=Community%20meeting%20with%20neighbors%20discussing%20safety%20and%20cooperation%20in%20residential%20setting%20with%20people%20working%20together%20for%20neighborhood%20security&width=400&height=250&seq=10&orientation=landscape",
      readTime: "4 min read"
    },
    {
      id: 11,
      title: "Cultural Dance Group Preserves Heritage",
      excerpt: "A dedicated group of dancers is working to preserve traditional cultural dances, teaching them to new generations and performing at community events.",
      author: "Ana Martinez",
      date: "2023-12-20",
      category: "Culture",
      image: "https://readdy.ai/api/search-image?query=Traditional%20cultural%20dance%20performance%20with%20colorful%20costumes%20and%20dancers%20in%20cultural%20center%20setting%20with%20heritage%20preservation%20and%20artistic%20expression%20atmosphere&width=400&height=250&seq=11&orientation=landscape",
      readTime: "5 min read"
    },
    {
      id: 12,
      title: "Young Entrepreneurs Open Eco-Friendly Store",
      excerpt: "Two young entrepreneurs have opened a store specializing in eco-friendly products, promoting sustainable living in the community.",
      author: "Kevin Lee",
      date: "2023-12-18",
      category: "Innovation",
      image: "https://readdy.ai/api/search-image?query=Eco-friendly%20store%20with%20sustainable%20products%20young%20entrepreneurs%20and%20green%20merchandise%20in%20modern%20retail%20setting%20with%20environmental%20consciousness%20theme&width=400&height=250&seq=12&orientation=landscape",
      readTime: "6 min read"
    }
  ];

  const articles = [
    {
      id: 1,
      title: "Reviving Traditional Assamese Weaving in Modern Times",
      author: "Priya Sharma",
      location: "Sualkuchi, Assam",
      category: "Culture",
      image: "https://readdy.ai/api/search-image?query=Traditional%20Assamese%20handloom%20weaving%20woman%20working%20on%20silk%20fabric%2C%20authentic%20cultural%20scene%20with%20traditional%20patterns%20and%20vibrant%20colors%2C%20heritage%20craft%20preservation&width=400&height=250&seq=blog-1&orientation=landscape",
      excerpt: "How young artisans are breathing new life into centuries-old weaving traditions while adapting to modern market demands.",
      readTime: "5 min read",
      date: "2 days ago"
    },
    {
      id: 2,
      title: "The Young Innovators of Guwahati's Tech Scene",
      author: "Rahul Das",
      location: "Guwahati, Assam",
      category: "Youth",
      image: "https://readdy.ai/api/search-image?query=Young%20Indian%20tech%20entrepreneurs%20working%20in%20modern%20startup%20office%2C%20innovation%20and%20technology%20development%2C%20collaborative%20workspace%20with%20computers%20and%20creative%20energy&width=400&height=250&seq=blog-2&orientation=landscape",
      excerpt: "Meet the brilliant minds creating technological solutions for local problems and putting Northeast India on the global innovation map.",
      readTime: "7 min read",
      date: "1 week ago"
    },
    {
      id: 3,
      title: "Community Kitchen Feeds Hundreds During Floods",
      author: "Maya Gogoi",
      location: "Majuli, Assam",
      category: "Communities",
      image: "https://readdy.ai/api/search-image?query=Community%20volunteers%20serving%20food%20during%20flood%20relief%2C%20people%20helping%20each%20other%2C%20humanitarian%20aid%20and%20community%20support%20in%20rural%20Indian%20setting&width=400&height=250&seq=blog-3&orientation=landscape",
      excerpt: "When floods hit Majuli island, the local community came together to ensure no one went hungry. A story of resilience and unity.",
      readTime: "4 min read",
      date: "3 days ago"
    },
    {
      id: 4,
      title: "The Secret Behind Assam's Famous Tea Gardens",
      author: "Ankit Borah",
      location: "Jorhat, Assam",
      category: "Micro-Knowledge",
      image: "https://readdy.ai/api/search-image?query=Assam%20tea%20garden%20workers%20picking%20tea%20leaves%2C%20lush%20green%20tea%20plantation%20landscape%2C%20traditional%20tea%20cultivation%20process%20with%20workers%20in%20scenic%20mountain%20setting&width=400&height=250&seq=blog-4&orientation=landscape",
      excerpt: "Discover the fascinating process behind Assam tea production and the generations of knowledge passed down through tea garden families.",
      readTime: "6 min read",
      date: "5 days ago"
    },
    {
      id: 5,
      title: "Preserving Tribal Languages Through Digital Storytelling",
      author: "Ritu Munda",
      location: "Diphu, Assam",
      category: "Culture",
      image: "https://readdy.ai/api/search-image?query=Tribal%20elder%20sharing%20stories%20with%20young%20people%2C%20cultural%20knowledge%20transfer%2C%20traditional%20tribal%20community%20gathering%20with%20authentic%20cultural%20elements%20and%20storytelling%20tradition&width=400&height=250&seq=blog-5&orientation=landscape",
      excerpt: "How digital platforms are helping preserve endangered tribal languages and oral traditions for future generations.",
      readTime: "8 min read",
      date: "1 week ago"
    },
    {
      id: 6,
      title: "From Village to Victory: A Young Athlete's Journey",
      author: "Bikash Kalita",
      location: "Nagaon, Assam",
      category: "Youth",
      image: "https://readdy.ai/api/search-image?query=Young%20Indian%20athlete%20training%20in%20rural%20village%20setting%2C%20sports%20achievement%20and%20determination%2C%20inspiring%20youth%20sports%20story%20with%20traditional%20village%20background&width=400&height=250&seq=blog-6&orientation=landscape",
      excerpt: "The inspiring story of how a young athlete from a remote village overcame challenges to represent India at international competitions.",
      readTime: "6 min read",
      date: "4 days ago"
    }
  ];

  const handleLoadMore = () => {
    setIsLoading(true);
    // Simulate loading delay
    setTimeout(() => {
      setVisibleStories(prev => Math.min(prev + 3, allStories.length));
      setIsLoading(false);
    }, 1000);
  };

  const displayedStories = allStories.slice(0, visibleStories);
  const hasMoreStories = visibleStories < allStories.length;

  const filteredArticles = articles.filter(article => {
    const matchesFilter = activeFilter === 'All' || article.category === activeFilter;
    const matchesSearch = article.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         article.author.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         article.location.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Community Stories</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover inspiring stories, innovations, and cultural moments shared by our community members
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {['All', 'Culture', 'People', 'Youth', 'Innovation'].map((category) => (
            <button
              key={category}
              className="px-6 py-2 rounded-full border-2 border-red-700 text-red-700 hover:bg-red-700 hover:text-white transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              {category}
            </button>
          ))}
        </div>

        {/* Search and Filters */}
        <div className="flex flex-col lg:flex-row gap-6 mb-12">
          {/* Search */}
          <div className="flex-1">
            <div className="relative">
              <i className="ri-search-line absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-xl"></i>
              <input
                type="text"
                placeholder="Search stories, authors, or locations..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent text-sm"
              />
            </div>
          </div>

          {/* Filters */}
          <div className="flex gap-2 overflow-x-auto">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setActiveFilter(filter)}
                className={`px-6 py-3 rounded-full font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                  activeFilter === filter
                    ? 'bg-red-700 text-white'
                    : 'bg-white text-gray-600 hover:bg-red-50 hover:text-red-700 border border-gray-200'
                }`}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>

        {/* Stories Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {displayedStories.map((story) => (
            <article key={story.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img
                  src={story.image}
                  alt={story.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-red-700 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {story.category}
                  </span>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {story.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">
                  {story.excerpt}
                </p>
                
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <div className="flex items-center gap-2">
                    <i className="ri-user-line"></i>
                    <span>{story.author}</span>
                  </div>
                  <div className="flex items-center gap-4">
                    <div className="flex items-center gap-1">
                      <i className="ri-calendar-line"></i>
                      <span>{story.date}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <i className="ri-time-line"></i>
                      <span>{story.readTime}</span>
                    </div>
                  </div>
                </div>
                
                <button className="mt-4 w-full bg-red-700 text-white py-2 px-4 rounded-lg hover:bg-red-800 transition-colors duration-300 whitespace-nowrap cursor-pointer">
                  Read Full Story
                </button>
              </div>
            </article>
          ))}
        </div>

        {/* Articles Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredArticles.map((article) => (
            <article key={article.id} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
              <div className="relative overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-red-700 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {article.category}
                  </span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                  <i className="ri-map-pin-line"></i>
                  <span>{article.location}</span>
                  <span>•</span>
                  <span>{article.date}</span>
                </div>

                <h2 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2 group-hover:text-red-700 transition-colors duration-300">
                  {article.title}
                </h2>

                <p className="text-gray-600 mb-4 line-clamp-3">
                  {article.excerpt}
                </p>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                      <i className="ri-user-line text-red-700"></i>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900 text-sm">{article.author}</p>
                      <p className="text-gray-500 text-xs">Citizen Journalist</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-gray-500">
                    <span>{article.readTime}</span>
                    <button className="text-red-700 hover:text-red-800 font-medium cursor-pointer">
                      Read More
                    </button>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Load More Button */}
        {hasMoreStories && (
          <div className="text-center">
            <button 
              onClick={handleLoadMore}
              disabled={isLoading}
              className="bg-red-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-red-800 transition-colors duration-300 whitespace-nowrap cursor-pointer disabled:bg-gray-400 disabled:cursor-not-allowed"
            >
              {isLoading ? (
                <span className="flex items-center justify-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>
                  Loading...
                </span>
              ) : (
                'Load More Stories'
              )}
            </button>
          </div>
        )}

        {/* Load More */}
        <div className="text-center mt-12">
          <button className="bg-red-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-red-800 transition-colors duration-300 whitespace-nowrap cursor-pointer">
            Load More Stories
          </button>
        </div>

        {/* No More Stories Message */}
        {!hasMoreStories && visibleStories >= allStories.length && (
          <div className="text-center">
            <p className="text-gray-600 text-lg">You've reached the end of our stories!</p>
            <button 
              onClick={() => window.REACT_APP_NAVIGATE('/citizen-submission')}
              className="mt-4 bg-red-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-red-800 transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              Share Your Story
            </button>
          </div>
        )}

        {/* Share Section */}
        <div className="bg-red-50 rounded-2xl p-8 mt-16 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Have a Story to Share?
          </h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Join our community of citizen journalists and help document the rich culture and stories of Northeast India.
          </p>
          <button 
            onClick={() => window.REACT_APP_NAVIGATE('/citizen-submission')}
            className="bg-red-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-red-800 transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            Submit Your Story
          </button>
        </div>

      </div>
    </div>
  );
}

